import { createActionWithPayload } from './helpers';

export const setGlobalError = (errorType: string | undefined) =>
  createActionWithPayload('@error/GLOBAL', errorType);

export type ErrorActions = ReturnType<typeof setGlobalError>;
